'use client'
import {
  IMAGE_QUERY
} from "./chunk-CWCKFIZP.mjs";
import {
  gqlClient
} from "./chunk-6XSQRWIQ.mjs";
import {
  __async,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/api/categories/detail.ts
import { useQuery } from "@tanstack/react-query";
import { gql } from "graphql-request";
import { Exception } from "@wbk/logger";
var getCategoryDetail = (props) => __async(void 0, null, function* () {
  var _a;
  try {
    const res = yield gqlClient.request(
      gql`
        query getCategoryDetail($lang: String, $limit: Int, $skip: Int, $where: CategoryFilter) {
          categoryCollection(locale: $lang, limit: $limit, skip: $skip, where: $where) {
            items {
              id
              title
              slug
              order
              icon {${IMAGE_QUERY}}
              background {${IMAGE_QUERY}}
              tagsCollection(limit: 100) {
                total
                items {
                  id
                  slug
                  title
                  icon {${IMAGE_QUERY}}
                  linkedFrom(allowedLocales: "en") {
                    eventCollection {
                      total
                    }
                  }
                }
              }
            }
          }
        }
      `,
      __spreadValues({ order: "order_ASC" }, props)
    );
    return ((_a = res.categoryCollection.items) == null ? void 0 : _a[0]) || null;
  } catch (error) {
    throw new Exception({ error, name: "getCategoryDetailException" });
  }
});
var useGetCategoryDetail = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["getCategoryDetail", props],
    queryFn: () => getCategoryDetail(props)
  }, options));
};

export {
  useGetCategoryDetail
};
//# sourceMappingURL=chunk-Q6ZXP5B5.mjs.map